import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import clbRatings from "../../../../src/data/articles/cube-prospective-commander-legends-battle-for-baldurs-gate/clb-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  clbRatings,
  ProspectiveIntro,
  React
};